import { useWeb3React } from '@web3-react/core';
import React from 'react';
import cx from 'classnames';

function FooterComponent() {
  const { account } = useWeb3React();
  return (
    <div
      className={cx('footer', {
        logined: !!account
      })}
    >
      <div className='container'>
        <span className='copyright'>
          Copyright @2022 PIRATE X PIRATE Vesting Portal
        </span>
      </div>
    </div>
  );
}

export default FooterComponent;
